import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import BlogDetails from "../../Components/BlogDetails/BlogDetails";
import Footer from "../../Components/Common/Footer";
import BlogComments from "../../Components/BlogDetails/BlogComments";

class BlogDetailsPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <BlogDetails />
          <BlogComments />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default BlogDetailsPage;
